import { z } from 'zod';
// The reasons a partner can give for wanting its credits back. Owned here rather than by either
// surface, because the ops tool, the cockpit and the entity column all have to agree on the values.
export const reimbursementReasonSchema = z.enum([
    'TooManyCreditsBilled',
    'CannotDoThisWork',
    'NotEnoughCapacityOrOnHoliday',
    'UserIsTooFarAway',
    'UserNotReachable',
    'UserNotInterested',
    'LanguageBarrier',
]);
export const ReimbursementReason = reimbursementReasonSchema.enum;
export const REIMBURSEMENT_REASONS = reimbursementReasonSchema.options;
// Old rows can carry an empty reason, from before one was required.
export const storedReimbursementReasonSchema = z.union([reimbursementReasonSchema, z.literal('')]);
export const contactAttemptCountSchema = z.enum(['Once', 'TwoThreeTimes', 'MoreThenThreeTimes']);
export const ContactAttemptCount = contactAttemptCountSchema.enum;
